<script lang="ts">
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import {exists} from 'shared/utils/custom-utils';
    import {FOND_REPORT} from 'src/features/erp-sutor/sutor-fonds';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';
    import ReportFondDetail from '../components/ReportFondDetail.svelte';
    import ReportWorker from '../components/ReportWorker.svelte';
    import ReportMachine from '../components/ReportMachine.svelte';

    export let record: RecordRow;

    const machineField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.machineFieldId);
    const workerField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.workerFieldId);
    const reportedMachineField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.reportedMachineFieldId);
    const machineUnitField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.machineUnitFieldId);
</script>

<ReportFondDetail {record} on:text-note-edit>
    <svelte:fragment slot="heading">
        <ReportMachine {machineField}/>

        {#if exists(workerField)}
            <ReportWorker {workerField}/>
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="details">
        <LabeledValue label="Vykázáno">
            <GridFieldValue field={reportedMachineField} unitField={machineUnitField}/>
        </LabeledValue>
    </svelte:fragment>
</ReportFondDetail>